import {
  Avatar,
  Badge,
  Checkbox,
  Form,
  Input,
  Pagination,
  PaginationProps,
  Tooltip,
} from "antd";
import { FormProvider } from "../../../../common/provider/form/Form.provider";
import "./style.scss";
import { SimpleInput } from "../../../../common/components/simpleInput";
import { useEffect, useState } from "react";
import { IoMdAdd } from "react-icons/io";
import CustomModal from "../../../../common/components/Modal/CustomModal";
import { useQueryStaffPostForSelect } from "../../../../common/hooks/StaffPost";
import { useQueryStaffList } from "../../../employess/staff/core/_hooks";
import { Loader } from "../../../../common/components/Loader/Loader";
import {
  generateColorArray,
  getNumberOfALetter,
} from "../../../../utilities/random_color";
import { getFirstCharOfAstring } from "../../../../utilities/string";
import Spinner from "../../../../common/components/Spinner/Spinner";
import { TeamManagementService } from "../../core/_request";
import { HttpStatusCode } from "axios";
import { SearhcInput } from "../../../../common/components/searchInput/SearhcInput";
import { getAllStaff } from "../../../employess/staff/core/_request";

type CreateTeamFormType = {
  onClose: () => void;
  onSuccess: () => void;
  type: any;
  initialValue?: any;
};

const COLORS = generateColorArray(50);
const INITIAL_PAGINATION = {
  page: 1,
  itemsPerPage: 10,
};

const showTotal: PaginationProps["showTotal"] = (total: number) =>
  `Total ${total}`;

export const CreateTeamForm = ({
  onClose,
  onSuccess,
  type,
  initialValue,
}: CreateTeamFormType) => {
  const [form] = Form.useForm();

  const { data: staffPost, isLoading: isLoadingStaffPost } =
    useQueryStaffPostForSelect({
      departmentType: "EXPLOITATION",
    });

  // const { data: staffs, isLoading: isLoadingStaff } = useQueryStaffList();

  const [isOpenModalUser, setIsOpenModalUser] = useState<boolean>(false);
  const [selectedStaffPost, setSelectedStaffPost] = useState<any>();
  const [initialState, setInitialState] = useState<any>({});
  const [selectedStaff, setSelectedStaff] = useState<Array<any>>([]);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  const [isLoadingStaff, setIsLoadingStaff] = useState<boolean>(false);
  const [staffs, setStaffs] = useState<Array<any>>([]);
  const [staffsTotal, setStaffsTotal] = useState<number>(0);
  const [paginationsStaff, setPaginationStaff] = useState(INITIAL_PAGINATION);

  useEffect(() => {
    handleInitialState();
  }, []);

  useEffect(() => {
    getAllStaffsForList({ ...paginationsStaff });
  }, [paginationsStaff]);

  useEffect(() => {
    if (!isOpenModalUser) {
      setPaginationStaff(INITIAL_PAGINATION);
    }
  }, [isOpenModalUser]);

  useEffect(() => {
    setInitialState((prev: any) => ({
      ...prev,
      operationCategory: type,
    }));
  }, [type]);

  useEffect(() => {
    if (initialValue) {
      form.setFieldValue("name", initialValue?.name);
    } else {
      form.setFieldValue("name", "Equipe 1");
    }
    handleSetStaffPostValue();
    if (initialValue) {
      setInitialState((prev: any) => ({
        "@id": initialValue?.["@id"],
        id: initialValue?.["id"],
        ...prev,
      }));
    }
  }, [staffPost, initialValue]);

  const handleInitialState = () => {
    handleSetStaffPostValue();
  };

  const getAllStaffsForList = async (params: any) => {
    try {
      setIsLoadingStaff(true);
      const res = await getAllStaff({
        ...paginationsStaff,
        ...params,
      });
      if (res?.status === HttpStatusCode.Ok) {
        if (Array.isArray(res?.data?.member)) {
          setStaffs(res?.data?.member);
          setStaffsTotal(res?.data?.totalItems);
        } else {
          setStaffs([]);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingStaff(false);
    }
  };

  const handleSetStaffPostValue = (e?: any) => {
    e?.preventDefault();
    if (staffPost?.length) {
      if (!initialValue) {
        setInitialState((prev: any) => ({
          ...prev,
          modelTeamStaff: staffPost?.map((item: any) => ({
            staffPost: item,
            // staffPost: item?.["@id"],
            staff: [],
            name: item?.name,
          })),
        }));
      } else {
        setInitialState((prev: any) => ({
          ...prev,
          modelTeamStaff: staffPost?.map((item: any) => {
            const finded = initialValue?.modelTeamStaff?.find(
              (elem: any) => elem?.staffPost?.["@id"] === item?.["@id"]
            );
            if (!finded) {
              return {
                staffPost: item,
                staff: [],
                name: item?.name,
              };
            } else {
              return {
                ...finded,
                name: finded?.staffPost?.name,
              };
            }
          }),
        }));
      }
    }
  };

  const handleIsOpenModalUser = () => {
    setIsOpenModalUser((prev: boolean) => !prev);
  };

  const onCloseUserModal = () => {
    setIsOpenModalUser(false);
  };

  const handleClickOnStaffPost = (value: any) => {
    setSelectedStaffPost(value);
    setSelectedStaff(value?.staff);
    handleIsOpenModalUser();
  };

  const handleCheckUser = (e: any) => {
    if (
      selectedStaff?.length &&
      selectedStaff?.some((item) => item?.["@id"] == e?.["@id"])
    ) {
      const allStaffs = selectedStaff;
      setSelectedStaff(
        allStaffs.filter((item) => item?.["@id"] !== e?.["@id"])
      );
    } else {
      setSelectedStaff((prev: any) => [...prev, e]);
    }
  };

  const onClicOnValidateStaff = () => {
    setInitialState((prev: any) => ({
      ...prev,
      modelTeamStaff: prev?.modelTeamStaff?.map((staff: any) => {
        if (staff?.["staffPost"] === selectedStaffPost?.["staffPost"]) {
          return {
            ...staff,
            staff: selectedStaff,
          };
        } else {
          return staff;
        }
      }),
    }));
    onCloseUserModal();
    setSelectedStaff([]);
  };

  const onCloseHandler = (e: any) => {
    e?.preventDefault();
    onClose();
    handleSetStaffPostValue();
  };

  const handleClickOnSaveTeam = async (values: any) => {
    try {
      setIsLoadingSubmit(true);

      const dataToPost = {
        ...values,
        ...initialState,
        modelTeamStaff: initialState?.modelTeamStaff
          ?.filter((item: any) => item?.staff?.length)
          ?.map((item: any) => ({
            ...(item?.["@id"]
              ? {
                  "@id": item?.["@id"],
                }
              : {}),
            staffPost: item?.staffPost?.["@id"],
            staff: item?.staff?.map((staffItem: any) => staffItem?.["@id"]),
          })),
      };
      if (!dataToPost?.["@id"]) {
        const res = await TeamManagementService.createTeam(dataToPost);

        if (res?.status === HttpStatusCode.Created) {
          onClose();
          handleInitialState();
          onSuccess();
        }
      } else {
        delete dataToPost?.operationCategory;
        console.log("dataToPost", dataToPost);

        const res = await TeamManagementService.updateTeam(dataToPost);
        if (res?.status === HttpStatusCode.Ok) {
          onClose();
          handleInitialState();
          onSuccess();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div>
      <Loader isLoading={isLoadingStaffPost || isLoadingStaff} />
      <FormProvider
        Form={Form}
        form={form}
        debug
        onFinish={(values: any) => {
          handleClickOnSaveTeam(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="team_form__container">
          <div className="">
            <SimpleInput
              Form={Form}
              name={"name"}
              // label="Equipe"
              rules={[
                {
                  required: true,
                  message: "Ce champs est obligatoire",
                },
              ]}
              customInput={<Input />}
            />
          </div>

          <div className="">
            <div className="team_form__team_item">
              <table className="team_form__team_table">
                <tbody>
                  {initialState?.modelTeamStaff?.map(
                    (item: any, index: number) => (
                      <tr key={index}>
                        <td className="team_form__team_table_td">
                          <span className="team_form__team_item_title">
                            {item?.name}
                          </span>
                        </td>
                        <td className="team_form__team_table_td">
                          <Avatar.Group>
                            {item?.staff?.map((staffItem: any, key: number) => (
                              <Tooltip
                                title={staffItem?.fullname}
                                placement="top"
                                key={key}
                              >
                                <Avatar
                                  style={{
                                    backgroundColor:
                                      COLORS[
                                        getNumberOfALetter(
                                          getFirstCharOfAstring(
                                            staffItem?.fullname
                                          )
                                        )
                                      ],
                                  }}
                                >
                                  {getFirstCharOfAstring(staffItem?.fullname)}
                                </Avatar>
                              </Tooltip>
                            ))}

                            <Avatar
                              style={{
                                backgroundColor: "white",
                                borderColor: "rgb(208, 206, 206)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClickOnStaffPost(item)}
                            >
                              <IoMdAdd
                                style={{
                                  color: "rgb(208, 206, 206)",
                                  height: "20px",
                                  width: "20px",
                                }}
                              />
                            </Avatar>
                          </Avatar.Group>
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="team_form__footer_wrapper">
            <button
              className="team_form__button_secondary"
              onClick={onCloseHandler}
            >
              Annuler
            </button>
            <button
              className="team_form__button_secondary"
              onClick={handleSetStaffPostValue}
            >
              Réinitialiser{" "}
            </button>
            <button
              className="team_form__button_primary"
              type="submit"
              disabled={isLoadingStaffPost}
            >
              {isLoadingSubmit ? <Spinner /> : "Enregistrer"}
            </button>
          </div>
        </div>
      </FormProvider>

      {isOpenModalUser && (
        <CustomModal
          isOpen={isOpenModalUser}
          hanldeCloseModal={handleIsOpenModalUser}
          title={selectedStaffPost?.name}
          width={800}
        >
          <Loader isLoading={isLoadingStaff} />
          <SearhcInput
            onSearch={(e) => {
              setPaginationStaff((prev) => ({ ...prev, page: 1, fullname: e }));
            }}
          />
          <table className="team_form__team_table">
            <thead>
              <tr>
                <th className="team_form__team_table_th"> Nom </th>
              </tr>
            </thead>
            <tbody>
              {staffs?.map((item: any, key: number) => (
                <tr key={key}>
                  <td className="team_form__team_table_td">
                    <Checkbox
                      checked={selectedStaff.some(
                        (s) => s?.["@id"] === item?.["@id"]
                      )}
                      onChange={() => handleCheckUser(item)}
                    >
                      <span className="">{item?.fullname}</span>
                    </Checkbox>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="mt-4 d-flex w-100 justify-content-end">
            <Pagination
              className="w-full"
              simple
              showSizeChanger
              showTotal={showTotal}
              defaultCurrent={1}
              current={paginationsStaff?.page}
              pageSize={paginationsStaff?.itemsPerPage || 10}
              total={staffsTotal || 0}
              onChange={(page, itemsPerPage) => {
                setPaginationStaff({
                  page: page ?? 1,
                  itemsPerPage,
                });
              }}
            />
          </div>
          <div className="team_form__footer_wrapper mt-4">
            <button
              className="team_form__button_secondary"
              onClick={handleIsOpenModalUser}
            >
              Annuler
            </button>

            <button
              className="team_form__button_primary"
              onClick={onClicOnValidateStaff}
            >
              Valider{" "}
            </button>
          </div>
        </CustomModal>
      )}
    </div>
  );
};
